import React, { useEffect } from 'react';
import DropDown from './DropDown';
import { Link } from 'react-router-dom';

export default function Nav({ setMobileToggle }) {
  // Prevent scroll propagation when dropdown is open
  useEffect(() => {
    const handleDropdownScroll = (e) => {
      const dropdown = e.target.closest('.cs_nav .cs_nav_list .menu-item-has-children > ul');
      if (dropdown) {
        e.stopPropagation();
      }
    };

    // Add event listener for dropdown scroll
    document.addEventListener('wheel', handleDropdownScroll, { passive: false });
    document.addEventListener('touchmove', handleDropdownScroll, { passive: false });

    return () => {
      document.removeEventListener('wheel', handleDropdownScroll);
      document.removeEventListener('touchmove', handleDropdownScroll);
    };
  }, []);

  return (
    <ul className="cs_nav_list fw-medium text-uppercase">
      <li>
        <Link to="/" onClick={() => setMobileToggle(false)}>
          Home
        </Link>
      </li>
      <li>
        <Link to="/about" onClick={() => setMobileToggle(false)}>
          About
        </Link>
      </li>
      <li className="menu-item-has-children">
        <Link to="/service" onClick={() => setMobileToggle(false)}>
          Services
        </Link>
        <DropDown>
          <ul>
            {/* Core Services */}
            <li>
              <Link to="/service" onClick={() => setMobileToggle(false)}>
                Core Services
              </Link>
            </li>
            
            {/* Family Law */}
            <li>
              <Link to="/service/family-law" onClick={() => setMobileToggle(false)}>
                Family Law
              </Link>
            </li>
            
            {/* Property & Real Estate */}
            <li>
              <Link to="/service/property-law" onClick={() => setMobileToggle(false)}>
                Property & Real Estate
              </Link>
            </li>
            
            {/* Criminal & Civil Law */}
            <li>
              <Link to="/service/criminal-law" onClick={() => setMobileToggle(false)}>
                Criminal & Civil Law
              </Link>
            </li>
            
            {/* Business & Corporate */}
            <li>
              <Link to="/service/corporate-law" onClick={() => setMobileToggle(false)}>
                Business & Corporate
              </Link>
            </li>
            
            {/* Documentation & Process */}
            <li>
              <Link to="/service/documentation-process" onClick={() => setMobileToggle(false)}>
                Documentation & Process
              </Link>
            </li>
            
            {/* Immigration & Specialized */}
            <li>
              <Link to="/service/immigration-specialized" onClick={() => setMobileToggle(false)}>
                Immigration & Specialized
              </Link>
            </li>
          </ul>
        </DropDown>
      </li>
      <li>
        <Link to="/lawcademics" onClick={() => setMobileToggle(false)}>
          Lawcademics Hub
        </Link>
      </li>
      <li>
        <Link to="/blog" onClick={() => setMobileToggle(false)}>
          Blog
        </Link>
      </li>
      <li>
        <Link to="/team" onClick={() => setMobileToggle(false)}>
          Attorneys
        </Link>
      </li>
      <li>
          <Link to="/contact" onClick={() => setMobileToggle(false)}>
          Contact
        </Link>
      </li>
    </ul>
  );
}
